import { render, staticRenderFns } from "./SetupRulesRow.vue?vue&type=template&id=1cb8f910&scoped=true"
import script from "./SetupRulesRow.vue?vue&type=script&lang=js"
export * from "./SetupRulesRow.vue?vue&type=script&lang=js"
import style0 from "./SetupRulesRow.vue?vue&type=style&index=0&id=1cb8f910&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb8f910",
  null
  
)

export default component.exports